import { Component } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";

export interface ActionParamInterface {
    id: string,
    title: string,
    onClick: Function
}
interface CustomParamsType{
    actions: ActionParamInterface[];
}
type ICellRendererParamsWithGridType = ICellRendererParams & CustomParamsType;

@Component({
  selector: 'app-actions-renderer',
  templateUrl: './actions-renderer.component.html',
  styles: ['' +
  '.btn-actions .btn {padding: 0}' +
  '']
})
export class ActionsRendererComponent implements ICellRendererAngularComp {
    public params: ICellRendererParamsWithGridType;
    public colId: string;
    public rowId: number;
    public data: object;

    public actions: any[] = [];
    constructor() { }

    ngOnInit() {
    }

    agInit(params: ICellRendererParamsWithGridType): void {
        this.params = params;
        this.data = params.data;
        this.actions = this.params.actions;
    }

    refresh(params: any): boolean {
        return true;
    }

}
